import React from 'react'
import styled from 'styled-components'
import { ReactComponent as LoadingAnim } from '../../images/loader.svg'
/**
 * Home page per i non iscritti
 * @constructor
 */
const Loading: React.FC = () => {
  return (
    <Container>
      <LoadingAnim />
    </Container>
  )
}

export default Loading

//region Style

const Container = styled.div`
  width: 100%;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
`

//endregion
